module.exports = "/_next/static/images/d7a75315da8e8381eb6b25bf79034cd5-moneyboxes-left.jpg.webp";